/**
 * The provider consent URL from a `/api/calendar-connect` response, or a thrown error code the hook maps to
 * what the user sees. Kept free of runtime imports so it can be unit-tested (see Tests in CLAUDE.md).
 */
export function hostedCalendarLink(status: number, body: unknown): string {
  // The bridge answers 409 for an account with no Orion presence yet, whichever code it names — a state no
  // retry can clear. Anything else is transient.
  if (status === 409) throw new Error('recipient_not_found');
  const fields = (body ?? {}) as { url?: unknown; error?: unknown };
  if (status < 200 || status >= 300) {
    throw new Error(typeof fields.error === 'string' && fields.error ? fields.error : `${status}`);
  }
  if (typeof fields.url !== 'string' || !fields.url) throw new Error('missing_oauth_url');
  return fields.url;
}
